// extracted by mini-css-extract-plugin
export default {"flexContainer":"ChatEnd_flexContainer__RMO-4","chatEndContainer":"ChatEnd_chatEndContainer__qaGhi"};